import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Reveal } from "../components/shared";
import { InquiryForm } from "../components/InquiryForm";
import { Button } from "../components/ui/button";
import { Calendar, MapPin, Clock, Users, GraduationCap, Sparkles } from "lucide-react";

export default function Educators() {
  const [events, setEvents] = useState([]);
  useEffect(() => { api.get("/events").then(({ data }) => setEvents(data)).catch(() => {}); }, []);

  return (
    <div className="pt-28">
      <section className="max-w-7xl mx-auto px-6 py-12">
        <Reveal>
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-navy text-mustard text-xs font-semibold uppercase tracking-widest mb-4"><Sparkles className="h-3.5 w-3.5" /> New · Coming Soon</div>
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold text-navy tracking-tight max-w-3xl">Professional development for educators</h1>
          <p className="mt-5 text-lg text-navy/60 max-w-2xl leading-relaxed">We're building a space to share what we love with fellow early-childhood educators — hands-on workshops and courses inspired by the atelier, the garden, and mindful mealtimes. Join our list to be the first to know when registration opens.</p>
          <div className="mt-7">
            <InquiryForm type="educator_event" defaultProgram="Educator Professional Development" title="Notify Me About Educator Events"
              trigger={<Button size="lg" className="rounded-full bg-coral hover:bg-coral-dark text-white h-12 px-7 gap-2" data-testid="educators-notify-btn"><GraduationCap className="h-5 w-5" /> Join the Educator List</Button>} />
          </div>
        </Reveal>
      </section>

      <section className="max-w-7xl mx-auto px-6 pb-16">
        <Reveal><h2 className="font-heading text-2xl font-bold text-navy mb-8">Upcoming workshops & courses</h2></Reveal>
        <div className="grid md:grid-cols-3 gap-6">
          {events.map((e, i) => (
            <Reveal key={e.id} delay={i * 0.1}>
              <div className="bg-white rounded-3xl overflow-hidden shadow-[0_8px_30px_rgb(0,0,0,0.06)] h-full flex flex-col" data-testid={`event-card-${e.order}`}>
                <div className="relative h-44">
                  <img src={e.image} alt={e.title} className="w-full h-full object-cover" />
                  <span className="absolute top-3 left-3 px-3 py-1 rounded-full bg-mustard text-navy text-xs font-semibold">{e.format}</span>
                </div>
                <div className="p-6 flex-1 flex flex-col">
                  <h3 className="font-heading text-xl font-bold text-navy">{e.title}</h3>
                  <p className="text-navy/60 mt-2 leading-relaxed flex-1">{e.description}</p>
                  <ul className="mt-4 space-y-1.5 text-sm text-navy/70">
                    <li className="flex gap-2 items-center"><Calendar className="h-4 w-4 text-coral" /> {e.date}</li>
                    <li className="flex gap-2 items-center"><Clock className="h-4 w-4 text-coral" /> {e.time}</li>
                    <li className="flex gap-2 items-center"><MapPin className="h-4 w-4 text-coral" /> {e.location}</li>
                    <li className="flex gap-2 items-center"><Users className="h-4 w-4 text-coral" /> {e.audience}</li>
                  </ul>
                  <InquiryForm type="educator_event" defaultProgram={e.title} title={`Register Interest — ${e.title}`}
                    trigger={<Button variant="outline" className="mt-5 rounded-full border-navy/20 text-navy hover:bg-navy hover:text-white w-full" data-testid={`event-register-${e.order}`}>Register Interest</Button>} />
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
